import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer
      style={{
        backgroundColor: "#1a1f2e",
        borderTop: "1px solid #2d3748",
        padding: "20px 0",
        marginTop: "40px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 20px",
        }}
      >
        <style>
          {`
            @media (max-width: 768px) {
              .footer-content {
                flex-direction: column !important;
                gap: 8px !important;
              }
              .footer-content > div:nth-child(2),
              .footer-content > div:nth-child(4) {
                display: none !important;
              }
              .footer-text {
                font-size: 12px !important;
              }
              .footer-desktop-only {
                display: none !important;
              }
              .footer-bottom-line {
                display: flex !important;
                gap: 15px !important;
                justify-content: center !important;
                align-items: center !important;
              }
            }
            @media (min-width: 769px) {
              .footer-bottom-line {
                display: none !important;
              }
            }
          `}
        </style>
        <div
          className="footer-content"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "nowrap",
            gap: "10px",
          }}
        >
          <div
            className="footer-text"
            style={{ color: "#cbd5e0", fontSize: "14px", whiteSpace: "nowrap" }}
          >
            Made for Streamers with{" "}
            <svg
              width="16"
              height="14"
              viewBox="0 0 16 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                verticalAlign: "middle",
                marginBottom: "2px",
                padding: "0 2px",
              }}
            >
              <path
                d="M14.5 4.5C14.5 2.5 12.5 0.5 10.5 0.5C9 0.5 8 1.5 8 1.5C8 1.5 7 0.5 5.5 0.5C3.5 0.5 1.5 2.5 1.5 4.5C1.5 7 8 13 8 13C8 13 14.5 7 14.5 4.5Z"
                stroke="#9146FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>{" "}
            in California
          </div>

          <div style={{ color: "#4a5568", fontSize: "14px" }}>|</div>

          <a
            href="https://squidcode.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-text footer-desktop-only"
            style={{
              color: "#cbd5e0",
              textDecoration: "none",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#a855f7";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#cbd5e0";
            }}
          >
            2025-2026 © Squidcode LLC
          </a>

          <div style={{ color: "#4a5568", fontSize: "14px" }}>|</div>

          <Link
            to="/support"
            className="footer-text footer-desktop-only"
            style={{
              color: "#9146FF",
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: "500",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#a855f7";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#9146FF";
            }}
          >
            Support
          </Link>

          <div style={{ color: "#4a5568", fontSize: "14px" }}>|</div>

          <Link
            to="/best-twitch-ai-chatbot"
            className="footer-text footer-desktop-only"
            style={{
              color: "#cbd5e0",
              textDecoration: "none",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#a855f7";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#cbd5e0";
            }}
          >
            Compare
          </Link>

          <div style={{ color: "#4a5568", fontSize: "14px" }}>|</div>

          <Link
            to="/privacy"
            className="footer-text footer-desktop-only"
            style={{
              color: "#cbd5e0",
              textDecoration: "none",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#a855f7";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#cbd5e0";
            }}
          >
            Privacy
          </Link>

          <div style={{ color: "#4a5568", fontSize: "14px" }}>|</div>

          <Link
            to="/terms"
            className="footer-text footer-desktop-only"
            style={{
              color: "#cbd5e0",
              textDecoration: "none",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#a855f7";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#cbd5e0";
            }}
          >
            Terms
          </Link>
        </div>

        <div className="footer-bottom-line" style={{ marginTop: "8px" }}>
          <a
            href="https://squidcode.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-text"
            style={{
              color: "#cbd5e0",
              textDecoration: "none",
              fontSize: "12px",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#a855f7";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#cbd5e0";
            }}
          >
            2025-2026 © Squidcode LLC
          </a>

          <Link
            to="/support"
            className="footer-text"
            style={{
              color: "#9146FF",
              textDecoration: "none",
              fontSize: "12px",
              fontWeight: "500",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#a855f7";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#9146FF";
            }}
          >
            Support
          </Link>

          <Link
            to="/privacy"
            className="footer-text"
            style={{
              color: "#cbd5e0",
              textDecoration: "none",
              fontSize: "12px",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#a855f7";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#cbd5e0";
            }}
          >
            Privacy
          </Link>

          <Link
            to="/terms"
            className="footer-text"
            style={{
              color: "#cbd5e0",
              textDecoration: "none",
              fontSize: "12px",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#a855f7";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#cbd5e0";
            }}
          >
            Terms
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
